import type { UseQueryResult } from '@tanstack/react-query';

/**
 * Determine if one of the provided queries is performing its first api interaction
 *
 * initialLoad is determined by checking the query is pending (no data exists yet), and is actively fetching data.
 *  - pending when `isLoading = true`
 *  - fetching data when `isFetching = true`
 * only one of the provided queries needs to be performing an initial load to satisfy this check
 */
export function isInitialLoad(...queries: UseQueryResult[]): boolean {
  // if at least one of the provided queries is performing its fist load then return true
  return !!queries.find((query) => query.isLoading && query.isFetching);
}

/**
 * Determine if one of the provided queries is in an error state
 *
 * error is determined by checking the query is in error and not success
 */
export function isError(...queries: UseQueryResult[]): boolean {
  // if at least one of the provided queries is in error then return true
  return !!queries.find((query) => query.isError && !query.isSuccess && !isInitialLoad(query));
}
